// extracted by mini-css-extract-plugin
export var notificationHost = "_fi-0";